import EmptyUser from './EmptyUser';

export default EmptyUser;
